<template>
  <div class="parent">
    <div class="navi pt-2">
      <div class="notch"></div>
      <BNav fill>
        <BNavItem
          :to="{ name: 'MessageRooms' }"
          exact-active-class="active"
          class="navi-item"
        >
          メッセージ
          <BBadge
            v-if="unreadMessageCount > 0"
            pill
            variant="red"
            class="number-badge"
            data-testid="message-badge"
          >
            {{ unreadMessageCount }}
          </BBadge>
        </BNavItem>
        <BNavItem
          :to="{ name: 'Informations' }"
          exact-active-class="active"
          class="navi-item"
          data-testid="information-badge"
        >
          お知らせ
          <BBadge
            v-if="unreadInformationCount > 0"
            pill
            variant="red"
            class="number-badge"
          >
            {{ unreadInformationCount }}
          </BBadge>
        </BNavItem>
      </BNav>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
@Component
export default class MessagesNav extends Vue {
  @Prop({
    default: 0,
    type: Number
  })
  unreadMessageCount!: number;

  @Prop({
    default: 0,
    type: Number
  })
  unreadInformationCount!: number;
}
</script>

<style lang="scss" scoped>
.parent {
  padding-bottom: calc(env(safe-area-inset-top, 0px) + 49px);

  .navi {
    position: fixed;
    left: 0;
    z-index: 100;
    width: 100%;
    min-height: 40px;
    background: $white;
    border-bottom: 1px solid $gray-03;

    .notch {
      height: env(safe-area-inset-top, 0);
      background: $white;
    }

    .navi-item {
      font-size: 17px;
      font-weight: 600;

      :deep(a) {
        padding-right: 0;
        padding-left: 0;
        color: $gray-05;

        &.active,
        &:hover {
          color: $blue;
          border-bottom: 2px solid $blue;
        }
      }

      .number-badge {
        font-weight: normal;
        vertical-align: 1px;
      }
    }
  }
}
</style>
